module.exports = "/assets/ceca07ea31bccaf0dc283e59c247e70d.jpg";